import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Code: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M1.6,3 L1.6,13 L0,13 L0,3 L1.6,3 Z M3.2,3 L3.2,13 L2.4,13 L2.4,3 L3.2,3 Z M6.4,3 L6.4,13 L4,13 L4,3 L6.4,3 Z M8,3 L8,13 L7.2,13 L7.2,3 L8,3 Z M11.2,3 L11.2,13 L9.6,13 L9.6,3 L11.2,3 Z M14.4,3 L14.4,13 L12,13 L12,3 L14.4,3 Z M15.2,3 L16,3 L16,13 L15.2,13 L15.2,3 Z"
        />
    </SvgIcon>
);

export default Code;
